/* eslint-disable @typescript-eslint/no-unused-vars */
import LabelInput from 'components/custom/forms/LabelInput';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Button, Col, Table } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import apiEndpoints from 'constants/apiEndpoints';
import postData from 'services/postData';
import { currencyFormat } from 'helpers/utils';
import { useNavigate } from 'react-router-dom';
import { hrmsPaths } from 'constants/pagePath';

export default function EmployeeSaleryStructure(data) {
  const [loading, loadingMessage, manageLoading] = useManagePageLoading();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      pf_allow: '',
      previous_ctc: '',
      skilled_name: '',
      total_salary_amount: '',
      basic_salary: '',
      hra: '',
      conveyance_allowances: '',
      lta: '',
      special_allowances: '',
      gross_amount: '',
      pf_employer: '',
      deduction_esic_employee: '',
      deduction_epf_employee: '',
      deduction_p_tax: '',
      deduction_tds: '',
      deduction_esic_employer: '',
      total_deduction: '',
      esic_employer: '',
      category_id: '',
      category_name: '',
      user_id: '',
      user_type: '',
      total_payable_amount: '',
      minimum_wages_amount: '',
      con_allowance: '',
      bonus: '',
      deduction_epf_employer: '',
      arear_amount: ''
    },
    onSubmit: values => {
      console.log('Form values:', values);
    }
  });
  useEffect(() => {
    if (data.data.salary_structure) {
      formik.setFieldValue(
        'previous_ctc',
        data.data.professional_details.last_drown_salary || ''
      );
      formik.setFieldValue(
        'pf_allow',
        data.data.salary_structure.pf_allow === 'Yes'
      );
      formik.setFieldValue('user_id', data.data.salary_structure.user_id || '');
      formik.setFieldValue(
        'category_id',
        data.data.salary_structure.category_id || ''
      );

      formik.setFieldValue(
        'total_salary_amount',
        data.data.salary_structure.total_salary_amount || ''
      );
      formik.setFieldValue(
        'skilled_name',
        data.data.salary_structure.skilled_name || ''
      );
      formik.setFieldValue(
        'basic_salary',
        data.data.salary_structure.basic_salary || ''
      );
      formik.setFieldValue('hra', data.data.salary_structure.hra || '');
      formik.setFieldValue(
        'conveyance_allowances',
        data.data.salary_structure.conveyance_allowances || ''
      );
      formik.setFieldValue('lta', data.data.salary_structure.lta || '');
      formik.setFieldValue(
        'special_allowances',
        data.data.salary_structure.special_allowances || ''
      );
      formik.setFieldValue(
        'pf_employer',
        data.data.salary_structure.pf_employer
      );
      formik.setFieldValue(
        'esic_employer',
        data.data.salary_structure.esic_employer
      );
      formik.setFieldValue(
        'gross_amount',
        data.data.salary_structure.gross_amount
      );
      formik.setFieldValue(
        'deduction_epf_employee',
        data.data.salary_structure.deduction_epf_employee
      );
      formik.setFieldValue(
        'deduction_esic_employee',
        data.data.salary_structure.deduction_esic_employee
      );
      formik.setFieldValue(
        'deduction_p_tax',
        data.data.salary_structure.deduction_p_tax
      );
      formik.setFieldValue(
        'deduction_tds',
        data.data.salary_structure.deduction_tds
      );

      formik.setFieldValue(
        'total_payable_amount',
        data.data.salary_structure.total_payable_amount
      );
      formik.setFieldValue(
        'deduction_esic_employer',
        data.data.salary_structure.deduction_esic_employer
      );
      formik.setFieldValue(
        'total_deduction',
        data.data.salary_structure.total_deduction
      );

      formik.setFieldValue(
        'minimum_wages_amount',
        data.data.salary_structure.minimum_wages_amount
      );
      formik.setFieldValue(
        'con_allowance',

        data.data.salary_structure.con_allowance
      );
      formik.setFieldValue('bonus', data.data.salary_structure.bonus);
      formik.setFieldValue(
        'deduction_epf_employer',
        data.data.salary_structure.deduction_epf_employer
      );
      formik.setFieldValue(
        'arear_amount',
        data.data.salary_structure.arear_amount
      );
    }
  }, [data.data.salary_structure]);

  const [isEdit, setIsEdit] = useState(true);
  const handleEditSalery = () => {
    setIsEdit(false);
  };

  const handleGenerate = async () => {
    // manageLoading(true, 'Generating salary details...');
    // try {
    //   const valuesToSend = {
    //     total_salary_amount: formik.values.total_salary_amount,
    //     previous_ctc: formik.values.last_drown_salary,
    //     ...userDetails,
    //     user_id: createdID
    //   };
    //   const response = await postData(
    //     valuesToSend,
    //     apiEndpoints.employee.userSaleryCalculation
    //   );
    //   console.log('Processed API Response:', response);
    //   if (response.status) {
    //     setApiResponse(response.data);
    //   } else {
    //     console.error('API Error:', response.message);
    //   }
    // } catch (error) {
    //   console.error('Request Failed:', error);
    // } finally {
    //   manageLoading(false);
    // }
  };

  if (data?.data?.user_salary_structure !== 1) {
    return (
      <>
        <div className="text-danger">No Salary Structure Found</div>
        <div>
          <Button
            variant="primary"
            className="mt-3"
            onClick={() =>
              navigate(
                `${hrmsPaths.employee.update(data?.data?.personal_information.employee_id)}?tab=${5}`
              )
            }
          >
            Generate Salary Structure
          </Button>
        </div>
      </>
    );
  }
  return (
    <>
      <Row className="mb-2">
        <Col className="mt-2">
          <Row className="gx-2">
            <Col xs={12} sm={4}>
              <LabelInput
                errorProps={{ tooltip: false }}
                controlId={'total_salary_amount'}
                label={' Current Salary'}
                inputProps={{ readOnly: true }}
                formik={formik}
                // callbackOnChange={curr_salary => {
                //   formik.setFieldValue('total_salary_amount', curr_salary);
                // }}
              />
            </Col>

            <Col xs={12} sm={3}>
              <LabelInput
                errorProps={{ tooltip: false }}
                controlId={'previous_ctc'}
                label={'Previous Salary'}
                formik={formik}
                inputProps={{ readOnly: true }}
              />
            </Col>
            {isEdit ? (
              <Col
                xs={12}
                sm={'auto'}
                className="d-flex align-items-center pe-4"
              >
                <Button
                  variant="primary"
                  className="ms-2 mt-3 w-100"
                  onClick={handleEditSalery}
                  disabled
                >
                  Edit
                </Button>
              </Col>
            ) : (
              <Col xs={12} sm={2} className="d-flex align-items-center pe-4">
                <Button
                  variant="primary"
                  className="ms-2 mt-3 w-100"
                  onClick={handleGenerate}
                >
                  Generate
                </Button>
              </Col>
            )}
          </Row>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col md={6}>
          <div className="border rounded">
            <h4 className="text-center m-0 text-success fw-medium py-3 bg-light">
              Earnings
            </h4>

            <Table bordered className="m-0">
              <thead>
                <tr className="text-center">
                  <th>Earnings</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="align-middle">Basic</td>
                  <td>
                    <LabelInput
                      controlId={'basic_salary'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">House Rent Allowance</td>
                  <td>
                    <LabelInput
                      controlId={'hra'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">Conveyance Allowance</td>
                  <td>
                    <LabelInput
                      controlId={'con_allowance'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">LTA</td>
                  <td>
                    <LabelInput
                      controlId={'lta'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">Special Allowance</td>
                  <td>
                    <LabelInput
                      controlId={'special_allowances'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">PF (Employer)</td>
                  <td>
                    <LabelInput
                      controlId={'pf_employer'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">ESIC (Employer)</td>
                  <td>
                    <LabelInput
                      controlId={'esic_employer'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">Bonus</td>
                  <td>
                    <LabelInput
                      controlId={'bonus'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                {/* Corrected Last Row */}
                <tr>
                  <td className="fw-bold bg-success-100 text-success align-middle">
                    Total Earning
                  </td>
                  <td className="bg-success-100">
                    <LabelInput
                      controlId={'gross_amount'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>

        <Col md={6} className="mt-md-0 mt-2">
          <div className="border rounded">
            <h4 className="text-center text-danger m-0 fw-medium p-3 bg-light">
              Deduction
            </h4>
            <Table bordered className="m-0">
              <thead>
                <tr className="text-center">
                  <th>Deduction</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="align-middle">EPF (Employee)</td>
                  <td>
                    <LabelInput
                      controlId={'deduction_epf_employee'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">ESIC (Employee)</td>
                  <td>
                    <LabelInput
                      controlId={'deduction_esic_employee'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">P. Tax</td>
                  <td>
                    <LabelInput
                      controlId={'deduction_p_tax'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">TDS</td>
                  <td>
                    <LabelInput
                      controlId={'deduction_tds'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>

                <tr>
                  <td className="align-middle">ESIC Employer</td>
                  <td>
                    <LabelInput
                      controlId={'deduction_esic_employer'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle">Bonus</td>
                  <td>
                    <LabelInput
                      controlId={'bonus'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="align-middle py-4">--</td>
                  <td></td>
                </tr>
                <tr>
                  <td className="align-middle py-4 pt-5">--</td>
                  <td></td>
                </tr>
                {/* Corrected Last Row */}
                <tr>
                  <td
                    className="fw-bold bg-danger-100 text-danger align-middle"
                    style={{ borderBottomLeftRadius: '.375rem' }}
                  >
                    Total Deduction
                  </td>
                  <td className="bg-danger-100">
                    <LabelInput
                      controlId={'total_deduction'}
                      formik={formik}
                      inputProps={{ readOnly: true }}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>
        <Col md={12} className="fw-medium bg-light mt-4 border rounded">
          <div className="row mt-4">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center p-3 border-top">
                <h5 className="mb-0">Net Pay :</h5>
                <h5 className="mb-0 text-success">
                  {currencyFormat(
                    data?.data?.salary_structure?.total_payable_amount
                  ) || '--'}
                </h5>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {/* <PageLoader
        fixed={true}
        loading={loading}
        loadingMessage={loadingMessage}
      /> */}
    </>
  );
}
